import React from 'react';
import styled, { css } from 'styled-components';

const StyledMenu = styled.button`
  display: block;
  ${props => !props.isPhone && css`
    display: none;
  `}
  border: none;
  background: transparent;
  width: 2.5rem;
  cursor: pointer;
  :hover {
    opacity: .7
  }
  :focus {
    outline: none;
  }
`;

const BaseMenuBar = styled.span`
  background: white;
  width: 100%;
  height: .2rem;
  border-radius: .2em;
  display: block;
  margin: .25rem 0;
  transition: .2s all ease;
`;

const TopMenuBar = BaseMenuBar.extend`
  ${props => props.active && css`
    transform: rotate(45deg) translate(.35rem, .25rem);
  `}
`;

const CenterMenuBar = BaseMenuBar.extend`
  ${props => props.active && css`
    opacity: 0;
  `}
`;

const BottomMenuBar = BaseMenuBar.extend`
  ${props => props.active && css`
    transform: rotate(-45deg) translate(.35rem, -.25rem);
  `}
`;

export const HamburgerMenu = (props) => {
  const { active, handleOpen, isPhone } = props;
  return (
    <StyledMenu onClick={e => handleOpen(e)} isPhone={props.isPhone} >
      <TopMenuBar active={active} />
      <CenterMenuBar active={active} />
      <BottomMenuBar active={active} />
    </StyledMenu>
  );
};

export default HamburgerMenu;



// WEBPACK FOOTER //
// ./src/components/Index/Header/HamburgerMenu.jsx